<template>
  <v-form
    lazy-validation
    v-model="valid"
    @submit.prevent="submit"
    ref="form"
  >
      <v-container class="text-center">
        <v-text-field
          filled
          data-cy="FormUserPin-username"
          :label="$$t('username')"
          v-model="localUserPin.username"
        />
        <v-text-field
          filled
          data-cy="FormUserPin-pin"
          :label="$$t('pin')"
          v-model="localUserPin.pin"
          :prepend-inner-icon="mdiRefreshCircle"
          @click:prepend-inner="randomPin"
        />
        <div class="d-flex justify-end mb-6">
          <v-btn color="default" outlined class="ml-4 btn-cancel" @click="cancel"
            data-cy="FormUserPin-button-cancel">
            {{ $t('common.buttons.cancel') }}
          </v-btn>
          <v-btn color="primary" type="submit" class="ml-4" :loading="isSaving"
            data-cy="FormUserPin-button-save">
              {{ $t('common.buttons.save') }}
            </v-btn>
        </div>
      </v-container>
  </v-form>
</template>

<script>
import { mdiRefreshCircle } from '@mdi/js';
import loading from '@codehq/aurora-app-core/src/mixins/loading';

export default {
  name: 'FormUserPin',
  module: 'UserPin',
  mixins: [loading],
  props: {
    /**
    * Set the text box value. Default: undefined,
    */
    UserPin: {
      type: Object,
      default: undefined,
    },
  },
  data() {
    return {
      mdiRefreshCircle,
      /**
      * Hold form validation state
      */
      valid: false,
      /**
      * Local value used for property localUserPin
      */
      localUserPin: {},
    };
  },
  watch: {
    UserPin() {
      this.localUserPin = this.UserPin;
    },
  },
  created() {
    this.localUserPin = this.UserPin;
  },
  methods: {
    /**
     * generates a random 4 digit pin
     */
    randomPin() {
      this.localUserPin.pin = '';
      this.localUserPin.pin = (Math.floor(Math.random() * 10000) + 10000).toString().substring(1);
      this.$forceUpdate();
    },
    /** Submit Form data trigger
     * @event save
     * @type {object}
     */
    submit() {
      // validate
      if (this.$refs.form.validate()) {
        this.$emit('save', this.localUserPin);
        this.isSaving = true;
      }
    },
    /** Cancel form trigger
     * @event cancel
     */
    cancel() {
      this.$emit('cancel');
    },
  },
};
</script>

<docs>
# FormUserPin example

'''js
<FormUserPin :UserPin="UserPin" />
'''
</docs>
